import { SortOrder } from "../sort-order";

export class TriggerFilters {
  name: string;
  active: boolean;
  entityType: string;
  entityUuid: string;
  serialNumber: string;
  alias: string;
  isUserTrigger: boolean;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
